import { combineReducers } from 'redux';
import cmsNodes from './cms.reducer';
import deleteConfirmationModal from './deleteConfirmationModal.reducer';

export default combineReducers({ cmsNodes, deleteConfirmationModal });
